import * as React from 'react';
import { useState } from 'react';
import styled from 'styled-components';
import { rem } from 'polished';
import {
  FlexCol,
  FlexColCenter,
  FlexColCenterVertical,
  FlexRowCenterVertical,
} from '../../Defaults/Flexbox/Flexbox';
import { __ } from 'react-i18n';
import { linkCss, SidebarLink } from './SidebarLink';
import { IconImg, TextP } from '../../..';
import { DsiSvgIcon, IconType } from '../General/SvgIcon';
import { Modal } from '../../Defaults/Modal/Modal';
import { formatPrice, prop } from '../../../utilities';

interface Props {
  items: Array<{
    name: string;
    url: string;
    active: boolean;
  }>;
  handleLogout?: () => void;
  withoutLogout?: boolean;
  userData: any;
  currency: string;
  userFinancialData?: any;
}

function Sidebar({
  items,
  handleLogout,
  withoutLogout,
  userData,
  currency,
  userFinancialData,
}: Props) {
  const articlesComponent =
    items &&
    items.map((s, i) => {
      return (
        <SidebarLink url={s.url} key={i} title={s.name} active={s.active} />
      );
    });

  const [isOpenPerson1, setIsOpenPerson1] = useState(true);
  const [isOpenPerson2, setIsOpenPerson2] = useState(true);

  const [isMobileInfoOpen, setIsMobileInfoOpen] = useState(false);

  const person1Rotation = isOpenPerson1 ? 180 : 0;
  const person2Rotation = isOpenPerson2 ? 180 : 0;

  const handleInfoClick = () => {
    setIsMobileInfoOpen(true);
  };

  const closeInfo = () => {
    setIsMobileInfoOpen(false);
  };

  const renderContactAndPaymentsModal = () => {
    return (
      <Modal
        style={{ height: '85%' }}
        size={'medium'}
        showX={true}
        closeModal={closeInfo}
      >
        {renderContactAndPayments()}
      </Modal>
    );
  };

  const hasUserData = !!userData;
  const hasToPaySum = prop(userFinancialData, 'financial.debt');
  const hasToPaySumExpired = prop(userFinancialData, 'financial.debt_expired');
  const creditSum = prop(userData, 'outer_payload.@_ComCus_Credit')
    ? prop(userData, 'outer_payload.@_ComCus_Credit')
    : prop(userData, 'parent.outer_payload.@_ComCus_Credit')
    ? prop(userData, 'parent.outer_payload.@_ComCus_Credit')
    : '';
  const freeCreditSum = prop(userFinancialData, 'financial.free_credit');
  const daysToPay = prop(userData, 'outer_payload.@_ComCus_PayTI')
    ? prop(userData, 'outer_payload.@_ComCus_PayTI')
    : prop(userData, 'parent.outer_payload.@_ComCus_PayTI')
    ? prop(userData, 'parent.outer_payload.@_ComCus_PayTI')
    : '';

  const hasSr = prop(userFinancialData, 'persons.sr');
  const srImage = prop(userFinancialData, 'persons.sr.image');
  const srName = prop(userFinancialData, 'persons.sr.@_ConInt_FName')
    ? `${prop(userFinancialData, 'persons.sr.@_ConInt_FName') || ''}  ${prop(
        userFinancialData,
        'persons.sr.@_ConInt_LName',
      ) || ''}`
    : '';
  const srPhone = prop(userFinancialData, 'persons.sr.@_ConInt_TelMob');
  const srEmail = prop(userFinancialData, 'persons.sr.@_ConInt_EMail');

  const hasDp = prop(userFinancialData, 'persons.dp');
  const dpImage = prop(userFinancialData, 'persons.dp.image');
  const dpName = prop(userFinancialData, 'persons.dp.@_ConInt_FName')
    ? `${prop(userFinancialData, 'persons.dp.@_ConInt_FName') || ''}  ${prop(
        userFinancialData,
        'persons.dp.@_ConInt_LName',
      ) || ''}`
    : '';
  const dpPhone = prop(userFinancialData, 'persons.dp.@_ConInt_TelMob');
  const dpEmail = prop(userFinancialData, 'persons.dp.@_ConInt_EMail');

  const renderContactAndPayments = () => {
    return (
      <>
        <ContactWrapper>
          {hasSr && (
            // tslint:disable-next-line:jsx-no-lambda
            <Person onClick={() => setIsOpenPerson1(!isOpenPerson1)}>
              <StyledTextP>{`${__('Obchodný zástupca')}`}</StyledTextP>
              {!isMobileInfoOpen && (
                <IconImg
                  rotate={person1Rotation}
                  src={'/images/dsi/arrow-down.svg'}
                  alt="arrow-icon"
                  width={16}
                  height={16}
                  cursor={'pointer'}
                />
              )}
            </Person>
          )}
          {hasSr && (
            <PersonContent isOpen={isOpenPerson1 || isMobileInfoOpen}>
              <FlexRowCenterVertical>
                <PersonImage
                  alt={`${__('Obrázok používateľa')}`}
                  src={'/images/dsi/img_avatar.png'}
                />
                <FlexColCenterVertical>
                  <StyledTextP marginBottom={4}>{srName}</StyledTextP>
                  {srPhone ? (
                    <TextP>
                      <ContactPhone href={`tel:${srPhone}`}>
                        {srPhone}
                      </ContactPhone>
                    </TextP>
                  ) : null}
                  {srEmail ? (
                    <ContactEmailWrapper>
                      <ContactPhone href={`mailto:${srEmail}`}>
                        {srEmail}
                      </ContactPhone>
                    </ContactEmailWrapper>
                  ) : null}
                </FlexColCenterVertical>
              </FlexRowCenterVertical>
            </PersonContent>
          )}
          {hasDp && (
            //  tslint:disable-next-line:jsx-no-lambda
            <Person onClick={() => setIsOpenPerson2(!isOpenPerson2)}>
              <StyledTextP>{`${__('Distribučný pracovník')}`}</StyledTextP>
              {!isMobileInfoOpen && (
                <IconImg
                  rotate={person2Rotation}
                  src={'/images/dsi/arrow-down.svg'}
                  alt="arrow-icon"
                  width={16}
                  height={16}
                  cursor={'pointer'}
                />
              )}
            </Person>
          )}
          {hasDp && (
            <PersonContent isOpen={isOpenPerson2 || isMobileInfoOpen}>
              <FlexRowCenterVertical>
                <PersonImage
                  alt={`${__('Obrázok používateľa')}`}
                  src={'/images/dsi/img_avatar.png'}
                />
                <FlexColCenterVertical>
                  <StyledTextP marginBottom={4}>{dpName}</StyledTextP>
                  {dpPhone ? (
                    <TextP>
                      {' '}
                      <ContactPhone href={`tel:${dpPhone}`}>
                        {dpPhone}
                      </ContactPhone>
                    </TextP>
                  ) : null}
                  {dpEmail ? (
                    <ContactEmailWrapper>
                      <ContactPhone href={`mailto:${dpEmail}`}>
                        {dpEmail}
                      </ContactPhone>
                    </ContactEmailWrapper>
                  ) : null}
                </FlexColCenterVertical>
              </FlexRowCenterVertical>
            </PersonContent>
          )}
        </ContactWrapper>
        {hasUserData && (
          <PaymentsWrapper>
            {hasToPaySum ||
            hasToPaySum === 0 ||
            hasToPaySumExpired ||
            hasToPaySumExpired === 0 ? (
              <PayableWrapper borderBottom={true}>
                {hasToPaySum || hasToPaySum === 0 ? (
                  <PayableRow>
                    <Payables>{`${__('Záväzky')}`}</Payables>
                    <Payables>
                      {formatPrice(hasToPaySum || '0', currency, 2, false, ' ')}
                    </Payables>
                  </PayableRow>
                ) : null}
                {hasToPaySumExpired || hasToPaySumExpired === 0 ? (
                  <PayableRow>
                    <StyledPayables color={'red'}>{`${__(
                      'Záväzky po splatnosti',
                    )}`}</StyledPayables>
                    <StyledPayables color={'red'}>
                      {formatPrice(
                        hasToPaySumExpired || '0',
                        currency,
                        2,
                        false,
                        ' ',
                      )}
                    </StyledPayables>
                  </PayableRow>
                ) : null}
              </PayableWrapper>
            ) : null}
            <PayableWrapper>
              {creditSum ? (
                <PayableRow>
                  <Payables>{`${__('Kredit')}`}</Payables>
                  <Payables>
                    {formatPrice(creditSum * 1000, currency, 2, false, ' ')}
                  </Payables>
                </PayableRow>
              ) : null}
              {freeCreditSum || freeCreditSum === 0 ? (
                <PayableRow>
                  {/*<SvgIcon*/}
                  {/*    icon={IconType.creditCard}*/}
                  {/*    marginRight={12}*/}
                  {/*    fill={'#1E398D'}*/}
                  {/*/>*/}
                  <StyledPayables color={'blue'} marginBottom={16}>{`${__(
                    'Voľný kredit',
                  )}`}</StyledPayables>
                  <StyledPayables color={'blue'} marginBottom={16}>
                    {formatPrice(freeCreditSum || '0', currency, 2, false, ' ')}
                  </StyledPayables>
                </PayableRow>
              ) : null}
              {daysToPay ? (
                <PayableRow>
                  <Payables>{`${__('Splatnosť')}`}</Payables>
                  <Payables>{`${daysToPay} ${__('dní')}`}</Payables>
                </PayableRow>
              ) : null}
            </PayableWrapper>
          </PaymentsWrapper>
        )}
      </>
    );
  };

  return (
    <Wrapper>
      <InfoIcon onClick={handleInfoClick}>
        {hasUserData &&
          (hasToPaySum ||
            hasToPaySumExpired ||
            creditSum ||
            freeCreditSum ||
            daysToPay) && (
            <IconImg
              src={'/images/icons/info.svg'}
              width={24}
              height={24}
              rotate={180}
            />
          )}
      </InfoIcon>
      <SitemapWrapper>
        {articlesComponent}
        {!withoutLogout && (
          <LogoutButton onClick={handleLogout}>
            {__('Odhlásiť sa')}
          </LogoutButton>
        )}
      </SitemapWrapper>
      {/*
      <DesktopWrapper>{renderContactAndPayments()}</DesktopWrapper>
      {isMobileInfoOpen && renderContactAndPaymentsModal()}
      */}
    </Wrapper>
  );
}

const InfoIcon = styled(FlexColCenter)`
  display: none;
  min-width: ${rem(56)};
  padding: ${rem(16)};
  border-right: ${({ theme }) => theme.borders.banners};
  background-color: white;

  ${({ theme }) => theme.mediab.l925`
    display: flex;
    margin-left: -${rem(16)};
  `}
`;

const SitemapWrapper = styled(FlexCol)`
  width: 100%;
  max-width: ${rem(328)};
  overflow-y: auto;
  padding: ${rem(16)} ${rem(32)};
  margin-bottom: ${rem(2)};
  background-color: ${({ theme }) => theme.colors.categoryFilterBackground};

  ${({ theme }) => theme.mediab.l1300`
    max-width: ${rem(328)};
  `};

  ${({ theme }) => theme.mediab.l1150`
    max-width: ${rem(328)};
  `};

  ${({ theme }) => theme.mediab.l925`
    white-space: nowrap;
    flex-flow: row;
    margin:0;
    padding: ${rem(24)} 0;
    max-width: initial;
    padding: ${rem(24)} ${rem(16)};
    margin: 0 auto;
    width: 100%;
    background-color: white;
    padding: 0;
    margin-right: -${rem(16)};
  `}
`;

const DesktopWrapper = styled.div`
  ${({ theme }) => theme.mediab.l925`
    display: none;
  `}
`;

const PaymentsWrapper = styled(SitemapWrapper)`
  ${({ theme }) => theme.mediab.l925`
  flex-flow: column;
  background:white;
  margin-left: 0;
  width:100%;
  max-width:initial;
  `}
`;

const ContactWrapper = styled(SitemapWrapper)`
  ${({ theme }) => theme.mediab.l925`
  flex-flow: column;
  background:white;
  margin-left: 0;
  width:100%;
  max-width:initial;
  `}
`;

const Wrapper = styled.div`
  margin-right: ${rem(32)};
  max-width: ${rem(306)};
  width: 100%;
  border-radius: 4px 4px 0px 0px;
  min-width: ${rem(200)};

  ${({ theme }) => theme.mediab.l1300`
    max-width: ${rem(250)};
  `};

  ${({ theme }) => theme.mediab.l925`  
    display: flex;
    flex-flow: row;
    max-width: initial;
    box-shadow: ${theme.boxShadow.default};
  `}
`;

const Person = styled(FlexRowCenterVertical)`
  width: 100%;
  cursor: pointer;
  justify-content: space-between;
  padding: ${rem(16)} 0;
  margin-bottom: ${rem(16)};
`;

const PersonContent = styled(FlexColCenterVertical)<{ isOpen: boolean }>`
  display: ${({ isOpen }) => (isOpen ? 'flex' : 'none')};
  margin-bottom: ${rem(24)};
`;

const PersonImage = styled.img`
  width: ${rem(48)};
  height: ${rem(48)};
  margin-right: ${rem(16)};
  border-radius: 50%;
  flex-shrink: 0;
`;

const StyledTextP = styled(TextP)<{ marginBottom: number }>`
  font-weight: 500;
  margin-bottom: ${({ marginBottom }) =>
    marginBottom ? rem(marginBottom) : 0};
`;

const ContactPhone = styled.a`
  color: ${({ theme }) => theme.colors.textPrimary};
  font-size: ${rem(13)};
`;

const ContactEmailWrapper = styled(TextP)`
  /* overflow-wrap: break-word;
  word-break: break-word; */
`;

const PayableRow = styled(FlexRowCenterVertical)`
  justify-content: space-between;
`;

const Payables = styled(TextP)`
  margin-bottom: ${rem(16)};
`;

const StyledPayables = styled(Payables)<{
  color?: string;
  marginBottom?: number;
}>`
  font-weight: 500;
  color: ${({ theme, color }) =>
    color === 'red'
      ? theme.colors.dangerColor
      : color === 'blue'
      ? theme.colors.primary
      : theme.colors.textPrimary};
  margin-bottom: ${({ marginBottom }) =>
    marginBottom ? rem(marginBottom) : 0};
`;

const PayableWrapper = styled.div<{ borderBottom?: boolean }>`
  padding: ${rem(16)} 0;
  border-bottom: ${({ borderBottom, theme }) =>
    borderBottom ? theme.borders.primary : 0};
`;

const LogoutButton = styled.span`
  ${linkCss};
  cursor: pointer;
`;

export { Sidebar as DsiSidebar };
